import { gql } from '@apollo/client';
import { RefusalReasonFragment } from '../fragments/RefusalReasonFragment';
/**
 * @const RefusalReasonsQuery
 * @since 1.0.0
 */
export const RefusalReasonsQuery = gql `
  query RefusalReasonsQuery($input: RefusalReasonsInput) {
    refusalReasons(input: $input) {
      ...RefusalReasonFragment
    }
  }
  ${RefusalReasonFragment}
`;
